var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"jobs"},[_c('div',{staticClass:"container-byt"},[_c('Header',{attrs:{"withBtn":true,"fromJobs":true}})],1),_c('Hero'),_c('RecentOffers'),_c('CreateProfile'),_c('HowWeWork'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }